import { Button } from 'antd';
import { useState } from 'react';
import AssignButton from './AssignButton';
import ActivityPreview from '../panels/ActivityPreview';
const PreviewButton = ({
  tag,
  assignment,
  playlist,
  ...buttonProps
}) => {
  const [open, setOpen] = useState(false);
  return <>
			<Button {...buttonProps} onClick={() => setOpen(true)} children="Preview" data-sentry-element="Button" data-sentry-source-file="PreviewButton.jsx" />
			{open && <ActivityPreview onClose={() => setOpen(false)} previews={assignment.tasks.map((t, i) => ({
      name: t.name,
      url: t.previewURL,
      learningObjectiveHTML: assignment.instructions[i]
    }))} title={assignment.label} tag={tag} actionButton={<AssignButton assignment={assignment} playlist={playlist} size="small" type="primary" />} />}
		</>;
};
export default PreviewButton;